module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-articles"
  }, [_c('h3', [_vm._v("推荐热文")]), _vm._v(" "), (_vm.isLoading) ? _c('lh-loading') : _c('ul', _vm._l((_vm.hotArticles), function(item, index) {
    return _c('li', [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_vm._v(_vm._s(item.title))])], 1)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f3d1a70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/HotArticleList.vue
// module id = 1050
// module chunks = 40